
import { Component, Vue } from 'vue-property-decorator'
import ClickTooltip from '@/components/molecules/ClickTooltip.vue'

/**
 * 表示しきれないテキストを表示するツールチップ
 */
@Component({
  components: {
    ClickTooltip,
  },
})
export default class OverflowTextTooltip extends Vue {}
